// eslint-disable-next-line import/no-named-default
import TabUi from './TabUi'
import TabsUi from './TabsUi'

export default function Components(Vue) {
  Vue.component('TabUi', TabUi)
  Vue.component('TabsUi', TabsUi)
}



// WEBPACK FOOTER //
// ./src/js/components/app/UiTabs/index.js